<div class="email-preview-dialog p-3">
    <div id="emailPreview-16" title="Email preview" width="100%" height="650" [innerHTML]="emailPreview"></div>
</div>
<div class="modal-footer custom">
    <div class="d-table w-100">
        <span class="float-start"><button class="btn btn-sm btn-outline-primary emailPreviewBackButton" type="button" (click)="close()"><span translate>Button.Back</span></button></span>
    </div>
</div>
